import { useEffect, useState } from 'react'
import { Container, Row, Col, Button } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AppBreadcrumb from '../../components/ui/AppBreadcrumb';
import { setNavigateTo } from '../../redux/actions/ui.actions';
import { CLIENT_ADMIN_PROCEDURES } from '../../navigation/ROUTE_CONSTANTS';
import { deleteProcedure } from '../../redux/actions/procedures.actions';
import { getOneProcedure } from '../../services/proceduresService';

function ClientAdminProcedureDelete() {
    const dispatch = useDispatch();

    const { procedureId } = useParams();

    const [rowData, setRowData] = useState('');

    useEffect(() => {
        document.title = process.env.REACT_APP_SITE_TITLE + ' - Delete Procedure';
    });

    useEffect(() => {
        getOneProcedure(procedureId).then((data) => setRowData(data))
    }, [procedureId]);

    const handleCancel = () => {
        dispatch(setNavigateTo(CLIENT_ADMIN_PROCEDURES));
    }

    const handleDelete = () => {
        dispatch(deleteProcedure(rowData.id));
    }

    return (
        <Container className='mb-5 pb-5'>
            <Row>
                <Col>
                    <AppBreadcrumb headText="Delete Procedure" crumbList={[{ linkTo: CLIENT_ADMIN_PROCEDURES, label: 'Procedures' }]} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className='vstack col-md-4 mx-auto mt-4 text-center'>
                        <h4 className='pt-2 pb-3 text-center'>Delete Procedure</h4>
                        <h5 className='mt-3 mb-4 pt-2 pb-2'>Are you sure you want to remove this procedure?</h5>
                        <p>Procedure: <strong>{rowData.name}</strong></p>
                    </div>
                </Col>
            </Row>
            <Row>
                <p className="mt-4 mb-4 text-center">
                    <Button color={'success'} className="me-2" onClick={handleDelete}>
                        Delete Procedure
                    </Button>
                    <Button color={'secondary'} onClick={handleCancel} >
                        Cancel
                    </Button>
                </p>
            </Row>
        </Container>
    )
}

export default ClientAdminProcedureDelete
